var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMainWidgetStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 65,
    height: 65,
    rx: 5.5,
    fill: "#FDDBBA",
    stroke: "#F37321"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 24,
    height: 10,
    rx: 2,
    fill: "#F8AB7A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 19,
    width: 56,
    height: 42,
    rx: 2,
    fill: "#F8AB7A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1602 34.2734V47H23.5605V35.9258H23.4902L20.3965 37.9824V36.3828L23.5605 34.2734H25.1602ZM29.9766 44.7148L29.0098 43.748L32.0508 40.707L29.0098 37.7012L29.9766 36.7168L33.0176 39.7402L36.041 36.7168L37.0078 37.7012L33.9844 40.707L37.0078 43.748L36.041 44.7148L33.0176 41.6914L29.9766 44.7148ZM44.3379 34.2734V47H42.7383V35.9258H42.668L39.5742 37.9824V36.3828L42.7383 34.2734H44.3379Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMainWidgetStyle);
export default __webpack_public_path__ + "static/media/icon-main-widget-style.a0b2387119b546757d25c02156e236e1.svg";
export { ForwardRef as ReactComponent };